<template>
  <div class="mit-my-keys-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>My Keys</v-card-title>
            <v-card-subtitle class="caption">My borrowed keys</v-card-subtitle>
            <v-divider></v-divider>
              <MitMyBorrowedList></MitMyBorrowedList>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitMyBorrowedList from '../../components/borrowed/MitMyBorrowedList.vue';

  import MitBorrowService from '../../services/MitBorrowService.js';

  export default {
    name: 'MitMyKeysPage',
    components: {
      MitMyBorrowedList
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .mit-table {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .mit-my-borrowed-list {
    padding-bottom: 30px;
  }
</style>
